module.exports = __webpack_public_path__ + "img/thumbnail-afpia-video.f1412c9.jpg";